/**
 * The account label only when it is actually an address. `maskConnectedAccountLabel`
 * returns the literal string "Connected account" for a missing label, which is fine
 * as a collapsed-row placeholder but must never be shown as the account itself —
 * the Manage dialog says "we don't know" instead. See `ProviderAccountManagePanel`.
 */
export function resolveConnectedAccountEmail(label: string | null | undefined): string | null {
  const trimmed = label?.trim();
  if (!trimmed) return null;
  const atIndex = trimmed.indexOf("@");
  return atIndex > 0 && atIndex < trimmed.length - 1 ? trimmed : null;
}

export function maskConnectedAccountLabel(label: string | null | undefined): string {
  const trimmed = label?.trim();
  if (!trimmed) return "Connected account";
  const atIndex = trimmed.indexOf("@");
  if (atIndex <= 0) return "Connected account";
  const local = trimmed.slice(0, atIndex);
  const domain = trimmed.slice(atIndex + 1);
  const visibleLocal = local.length <= 2 ? local.charAt(0) : local.slice(0, 2);
  const domainParts = domain.split(".");
  const rootDomain = domainParts[0] ?? "";
  const suffix = domainParts.length > 1 ? `.${domainParts.at(-1)}` : "";
  const visibleDomain = rootDomain.length <= 2 ? rootDomain[0] : rootDomain.slice(0, 2);
  return `${visibleLocal}••••@${visibleDomain}•••${suffix}`;
}
